// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"128":"aae43d02","136":"3e1adb31","237":"8c612c5d","505":"5cc326ce","884":"1da6d327"}[chunkId] + ".chunk.js";
};